import { combineReducers } from 'redux';
import { InsurerPartnerReducer as insurerPartner } from './InsurerPartner';
import { ArticleSectionReducer as articleSection } from './ArticleSection';

export default combineReducers({
  insurerPartner,
  articleSection,
});
